module.exports = __webpack_public_path__ + "img/icon-white-10.6ff410c0.svg";